/*
  Grußkarte Layout-Engine (GKLayout) — v1
  Gemeinsame Satz-Engine für Warenkorb-Vorschau UND Druck-Tool (PDF).
  Beide Seiten MÜSSEN dieselbe Datei/denselben Stand benutzen, sonst weichen
  Vorschau und Druck voneinander ab. Version bei jeder Regel-Änderung erhöhen.

  Label: 57 × 32 mm (DYMO 11354), Rand 2 mm, Schrift G02 als NirmalaS-GK,
  11 pt → min 8.5 pt in 0.5-pt-Schritten, Zeilenhöhe 1.25, Blockabstand 0.4 em.
  Alle Blöcke linksbündig (v3), Block vertikal zentriert.
  v5: eigene Schrift NirmalaS-GK (NirmalaS + ğ ş İ ł ą ř đ ő …), Zeichensatz = Schrift.
*/
(function () {
  'use strict';
  if (window.GKLayout) return;

  var V = 5;
  var LABEL_W = 57, LABEL_H = 32, MARGIN = 2;
  var SAFE_W = LABEL_W - 2 * MARGIN;   // 53
  var SAFE_H = LABEL_H - 2 * MARGIN;   // 28
  var MAX_PT = 11, MIN_PT = 8.5, STEP = 0.5;
  var LINE_H = 1.25;                   // × Schriftgröße
  var BLOCK_GAP = 0.4;                 // × Schriftgröße, zwischen Anrede/Text/Unterschrift
  var WIDTH_SAFETY = 0.98;             // 2 % Reserve für Canvas-/PDF-Messdifferenzen
  var PT_TO_MM = 25.4 / 72;

  // Eigene Familie, NICHT 'NirmalaS': die Gravur-Vorschauen (G02) bleiben beim Original.
  var FONT_FAMILY = 'NirmalaS-GK';
  var FONT_NAME = 'G02';
  // Nur für den Browser (@font-face-Rückfall in loadFont): die Shopify-CDN liefert
  // diese .ttf als woff2 aus. jsPDF braucht echte TTF-Bytes → assets/grusskarte-schrift-ttf.js.
  var FONT_URL = 'https://cdn.shopify.com/s/files/1/1706/0569/files/NirmalaS-GK.ttf?v=1793593202';

  var LIMITS = { anrede: 40, text: 150, unterschrift: 40, total: 150, maxBreaks: 4 };

  // Genau die Zeichen, die NirmalaS-GK hat — ausgegeben von
  // scripts/build_grusskarte_schrift.py, geprüft von scripts/check-grusskarte-zeichen.py.
  // Alles andere würde in der Canvas-Vorschau vom Browser-Fallback gerendert, im PDF
  // aber stumm fehlen (2026-11-02: „meleğin“ wurde als „melein“ gedruckt).
  var ALLOWED_RE = /^[\u0020-\u007E\u00A0-\u0137\u0139-\u0148\u014C-\u017E\u0218-\u021B\u2013-\u2014\u2018-\u201A\u201C-\u201E\u2026\u20AC\n]*$/;
  function unsupportedChars(s) {
    var out = [], seen = {};
    for (var i = 0; i < s.length; i++) {
      var ch = s.charAt(i);
      if (!ALLOWED_RE.test(ch) && !seen[ch]) { seen[ch] = 1; out.push(ch); }
    }
    return out;
  }

  var measureCtx = null;
  function getMeasureCtx() {
    if (!measureCtx) {
      measureCtx = document.createElement('canvas').getContext('2d');
    }
    return measureCtx;
  }
  // Breite eines Strings in mm bei gegebener Schriftgröße (pt), gemessen mit NirmalaS-GK.
  function widthMm(str, pt) {
    var ctx = getMeasureCtx();
    ctx.font = '100px ' + FONT_FAMILY + ', sans-serif';
    return (ctx.measureText(str).width / 100) * pt * PT_TO_MM;
  }

  // Emojis/Symbole entfernen (die Schrift hat keine Glyphen dafür), Umbrüche normalisieren.
  function normalize(s) {
    return (s || '')
      .replace(/\r\n?/g, '\n')
      .replace(/[☀-➿⬀-⯿️‍]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '')
      .replace(/[ \t]+\n/g, '\n')
      .replace(/\n{3,}/g, '\n\n');
  }

  // Zeichenzählung: Leerzeichen zählen mit, jeder Zeilenumbruch zählt als 1 Zeichen.
  function count(anrede, text, unterschrift) {
    var a = normalize(anrede).trim(), t = normalize(text).trim(), u = normalize(unterschrift).trim();
    return {
      anrede: a.length,
      text: t.length,
      unterschrift: u.length,
      total: a.length + t.length + u.length,
      breaks: (t.match(/\n/g) || []).length
    };
  }

  // Einen Block (mit manuellen Umbrüchen) bei Schriftgröße pt umbrechen.
  // Bricht primär an Leerzeichen; ein zu langes zusammenhängendes Wort wird
  // hart auf Zeichenebene umbrochen (kein horizontaler Überlauf mehr).
  function wrapBlock(block, pt) {
    var maxW = SAFE_W * WIDTH_SAFETY;
    var out = [];
    var paragraphs = block.split('\n');
    for (var p = 0; p < paragraphs.length; p++) {
      var words = paragraphs[p].split(/ +/).filter(function (w) { return w.length; });
      if (!words.length) { out.push(''); continue; }
      var line = '';
      for (var i = 0; i < words.length; i++) {
        var word = words[i];
        if (widthMm(word, pt) > maxW) {
          // Wort passt nicht in eine Zeile → auf Zeichenebene hart umbrechen.
          if (line) { out.push(line); line = ''; }
          var frag = '';
          for (var ci = 0; ci < word.length; ci++) {
            var ch = word.charAt(ci);
            if (widthMm(frag + ch, pt) <= maxW) {
              frag += ch;
            } else if (frag) {
              out.push(frag); frag = ch;
            } else {
              out.push(ch); frag = '';
            }
          }
          line = frag; // Rest bleibt in der aktuellen Zeile (nimmt evtl. nächstes Wort auf)
          continue;
        }
        var probe = line ? line + ' ' + word : word;
        if (widthMm(probe, pt) <= maxW) {
          line = probe;
        } else {
          out.push(line);
          line = word;
        }
      }
      out.push(line);
    }
    return out;
  }

  // Versucht den kompletten Satz bei Schriftgröße pt. null = passt nicht.
  function tryLayout(a, t, u, pt) {
    var fontMm = pt * PT_TO_MM;
    var lineH = fontMm * LINE_H;
    var gap = fontMm * BLOCK_GAP;
    var blocks = [];
    if (a) { blocks.push({ lines: wrapBlock(a, pt), align: 'left' }); }
    if (t) { blocks.push({ lines: wrapBlock(t, pt), align: 'left' }); }
    if (u) { blocks.push({ lines: wrapBlock(u, pt), align: 'left' }); }
    if (!blocks.length) return { lines: [], h: 0, fontMm: fontMm };

    var nLines = 0;
    for (var b = 0; b < blocks.length; b++) nLines += blocks[b].lines.length;
    var h = nLines * lineH + (blocks.length - 1) * gap;
    if (h > SAFE_H) return null;

    var y = MARGIN + (SAFE_H - h) / 2;
    var lines = [];
    for (b = 0; b < blocks.length; b++) {
      for (var l = 0; l < blocks[b].lines.length; l++) {
        lines.push({
          text: blocks[b].lines[l],
          align: blocks[b].align,
          x: blocks[b].align === 'right' ? LABEL_W - MARGIN : MARGIN,
          y: y
        });
        y += lineH;
      }
      y += gap;
    }
    return { lines: lines, h: h, fontMm: fontMm };
  }

  /*
    Hauptfunktion. Eingaben: rohe Feldtexte. Ausgabe:
    { v, fits, sizePt, fontMm, lines:[{text,align,x,y}], counts, errors:[] }
    x/y in mm auf dem 57×32-Label, y = OBERKANTE der Zeile (Renderer: baseline 'top').
  */
  function layout(anrede, text, unterschrift) {
    var a = normalize(anrede).trim();
    var t = normalize(text).trim();
    var u = normalize(unterschrift).trim();
    var counts = count(a, t, u);
    var errors = [];
    if (counts.anrede > LIMITS.anrede) errors.push('anrede_max');
    if (counts.text > LIMITS.text) errors.push('text_max');
    if (counts.unterschrift > LIMITS.unterschrift) errors.push('unterschrift_max');
    if (counts.total > LIMITS.total) errors.push('total_max');
    if (counts.breaks > LIMITS.maxBreaks) errors.push('breaks_max');
    if (!t) errors.push('text_empty');
    var badChars = unsupportedChars(a + t + u);
    if (badChars.length) errors.push('chars');

    var result = null, pt = 0;
    if (!errors.length) {
      for (pt = MAX_PT; pt >= MIN_PT - 1e-9; pt -= STEP) {
        result = tryLayout(a, t, u, pt);
        if (result) break;
      }
    }
    if (result) {
      return { v: V, fits: true, sizePt: Math.round(pt * 10) / 10, fontMm: result.fontMm, lines: result.lines, counts: counts, errors: errors, badChars: badChars };
    }
    if (!errors.length) errors.push('too_long');
    // Notlayout in Minimalgröße für die (rote) Vorschau — Überlauf wird nicht beschnitten.
    var fallbackLines = [];
    var fontMm = MIN_PT * PT_TO_MM;
    var y = MARGIN;
    [{ s: a, al: 'left' }, { s: t, al: 'left' }, { s: u, al: 'left' }].forEach(function (blk) {
      if (!blk.s) return;
      var wrapped = wrapBlock(blk.s, MIN_PT) || blk.s.split('\n');
      wrapped.forEach(function (ln) {
        fallbackLines.push({ text: ln, align: blk.al, x: blk.al === 'right' ? LABEL_W - MARGIN : MARGIN, y: y });
        y += fontMm * LINE_H;
      });
      y += fontMm * BLOCK_GAP;
    });
    return { v: V, fits: false, sizePt: MIN_PT, fontMm: fontMm, lines: fallbackLines, counts: counts, errors: errors, badChars: badChars };
  }

  // Vollständigen zusammengesetzten Text liefern (für Bestell-Attribute).
  function fullText(anrede, text, unterschrift) {
    return [normalize(anrede).trim(), normalize(text).trim(), normalize(unterschrift).trim()]
      .filter(function (s) { return s.length; }).join('\n');
  }

  // Vorschau/Druckbild auf einen Canvas zeichnen (weißer Grund, Maßstab px pro mm).
  function draw(canvas, result) {
    var scale = canvas.width / LABEL_W;
    var ctx = canvas.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.save();
    // Auf den Druckbereich beschneiden: was nicht aufs Label passt, wird NICHT gezeigt.
    ctx.beginPath();
    ctx.rect(0, 0, LABEL_W * scale, LABEL_H * scale);
    ctx.clip();
    ctx.fillStyle = result.fits ? '#1a1a1a' : '#c22';
    ctx.textBaseline = 'top';
    ctx.font = (result.fontMm * scale) + 'px ' + FONT_FAMILY + ', sans-serif';
    for (var i = 0; i < result.lines.length; i++) {
      var ln = result.lines[i];
      ctx.textAlign = ln.align;
      ctx.fillText(ln.text, ln.x * scale, ln.y * scale);
    }
    ctx.restore();
  }

  // ---- Karten-Vorschau mit Marken-Hintergrund (NUR Warenkorb-Vorschau) --------
  // Zeigt die reale Grußkarte (Herz + URL) mit dem Text im weißen Feld. Der Druck
  // (DYMO 57×32) bleibt davon unberührt — hier wird nur schöner vorgeschaut.
  var FRAME_URL = 'https://cdn.shopify.com/s/files/1/1706/0569/files/Grusskarte2026.png?v=1784867883';
  // Weißes Feld als Bruchteil der Bildmaße (pixelgenau vermessen: 800×815).
  var FRAME_BOX = { x: 155 / 800, y: 242 / 815, w: (799 - 155 + 1) / 800, h: (610 - 242 + 1) / 815 };
  var frameImg = null, frameReady = false;

  function setFrameImage(img) { frameImg = img; frameReady = !!img; }

  // Karten-Hintergrundbild laden. Promise, löst auch bei Fehlschlag auf (dann
  // fällt drawFramed auf den weißen Kasten zurück).
  function loadFrame() {
    return new Promise(function (resolve) {
      if (frameReady) return resolve(frameImg);
      var img = new Image();
      img.onload = function () { frameImg = img; frameReady = true; resolve(img); };
      img.onerror = function () { resolve(null); };
      img.src = FRAME_URL;
    });
  }

  // Wie draw(), aber mit Karten-Hintergrund; Text wird in ein 57:32-Feld
  // innerhalb des weißen Kastens gesetzt (zentriert), damit „passt in Vorschau“
  // exakt „passt aufs Label“ bleibt.
  function drawFramed(canvas, result) {
    var W = canvas.width, H = canvas.height;
    var ctx = canvas.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    if (frameReady) {
      ctx.drawImage(frameImg, 0, 0, W, H);
    } else {
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, W, H);
    }
    var BX = FRAME_BOX.x * W, BY = FRAME_BOX.y * H, BW = FRAME_BOX.w * W, BH = FRAME_BOX.h * H;
    var ratio = LABEL_W / LABEL_H, w, h;
    if (BW / BH >= ratio) { h = BH; w = BH * ratio; } else { w = BW; h = BW / ratio; }
    var x0 = BX + (BW - w) / 2, y0 = BY + (BH - h) / 2;
    var scale = w / LABEL_W;
    ctx.save();
    // Auf den 57:32-Druckbereich beschneiden: Überlauf wird NICHT gezeigt.
    ctx.beginPath();
    ctx.rect(x0, y0, w, h);
    ctx.clip();
    ctx.fillStyle = result.fits ? '#1a1a1a' : '#c22';
    ctx.textBaseline = 'top';
    ctx.font = (result.fontMm * scale) + 'px ' + FONT_FAMILY + ', sans-serif';
    for (var i = 0; i < result.lines.length; i++) {
      var ln = result.lines[i];
      ctx.textAlign = ln.align;
      ctx.fillText(ln.text, x0 + ln.x * scale, y0 + ln.y * scale);
    }
    ctx.restore();
  }

  // Payload für den Druck-Link (Bestell-Attribut "Grußkarte Druck") kodieren.
  function encodePayload(obj) {
    return btoa(unescape(encodeURIComponent(JSON.stringify(obj)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function decodePayload(b64) {
    var s = b64.replace(/-/g, '+').replace(/_/g, '/');
    while (s.length % 4) s += '=';
    return JSON.parse(decodeURIComponent(escape(atob(s))));
  }

  // Schrift laden (Vorschau + Messung). Promise, löst auch bei Fehlschlag auf.
  function loadFont() {
    if (!document.getElementById('gk-fontface')) {
      var st = document.createElement('style');
      st.id = 'gk-fontface';
      st.textContent = "@font-face{font-family:" + FONT_FAMILY + ";src:url('" + FONT_URL + "');font-display:swap;}";
      document.head.appendChild(st);
    }
    if (document.fonts && document.fonts.load) {
      return document.fonts.load('16px ' + FONT_FAMILY).catch(function () {});
    }
    return Promise.resolve();
  }

  window.GKLayout = {
    V: V, LABEL_W: LABEL_W, LABEL_H: LABEL_H, MARGIN: MARGIN,
    MIN_PT: MIN_PT, MAX_PT: MAX_PT,
    FONT_FAMILY: FONT_FAMILY, FONT_NAME: FONT_NAME, FONT_URL: FONT_URL,
    LIMITS: LIMITS,
    normalize: normalize, count: count, layout: layout, fullText: fullText,
    draw: draw, drawFramed: drawFramed, loadFont: loadFont,
    loadFrame: loadFrame, setFrameImage: setFrameImage, FRAME_URL: FRAME_URL,
    encodePayload: encodePayload, decodePayload: decodePayload
  };
})();
